import { render, staticRenderFns } from "./CategoryTypeMetaData.vue?vue&type=template&id=08b8f375&scoped=true&"
import script from "./CategoryTypeMetaData.vue?vue&type=script&lang=js&"
export * from "./CategoryTypeMetaData.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTypeMetaData.vue?vue&type=style&index=0&id=08b8f375&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8f375",
  null
  
)

export default component.exports